import P1Content from "@/components/P1Content";
import NewsList from "../components/NewsList";
import styles from "./mobile.module.less";
import { useState } from "react";
import data from "../data";
import banner from "./imgs/bg.png";

const PAGE_SIZE = 12;
const MobileNews = () => {
  const [page, setPage] = useState(1);
  return (
    <div className={styles.page}>
      <div className={styles.p1}>
        <P1Content
          title="近期焦点"
          subtitle="聚焦实践，引领创新"
          showBtn={false}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <NewsList list={data.newsList.slice(0, page * PAGE_SIZE)} />
        <div
          className={styles.more_btn}
          onClick={() => {
            if (page * PAGE_SIZE >= data.newsList.length) {
              return;
            }
            setPage((prev) => prev + 1);
          }}
        >
          MORE
        </div>
      </div>
    </div>
  );
};
export default MobileNews;
